import { useEffect, useRef, useState } from "react";

const useImageWithFallback = (imageUrl: string, fallbackUrl: string) => {
  const [src, setSrc] = useState<string | null>(null);
  const isMounted = useRef(true);
  const retries = useRef(0);
  const timeoutRef = useRef<NodeJS.Timeout[]>([]);

  useEffect(() => {
    isMounted.current = true;

    const loadImage = () => {
      const img = new window.Image();
      img.src = imageUrl;

      img.onload = () => {
        if (isMounted.current) setSrc(imageUrl);
      };

      img.onerror = () => {
        retries.current += 1;
        if (retries.current < 3) {
          const timeoutId = setTimeout(loadImage, 800);
          timeoutRef.current.push(timeoutId);
        } else {
          // eslint-disable-next-line no-lonely-if
          if (isMounted.current) {
            setSrc(fallbackUrl);
            // if (window?.Sentry) {
            //   window.Sentry.captureException(
            //     new Error(`Failed to load image after 12 attempts: ${imageUrl}`),
            //     { level: "warning", extra: { imageUrl } },
            //   );
            // }
          }
        }
      };
    };

    if (typeof window !== "undefined") {
      loadImage();
    }

    return () => {
      isMounted.current = false;
      timeoutRef.current.forEach(clearTimeout);
    };
  }, [imageUrl, fallbackUrl]);

  return src;
};

export default useImageWithFallback;
